import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../store/UserContext';
import Skeleton from './Skeleton';

/**
 * 简单登录态路由守卫组件
 * 仅检查用户是否已登录，不进行细粒度权限控制
 */
const SimpleAuthGuard = ({
    children,
    fallback = null,
    showSkeleton = true
}) => {
    const { user, loading } = useUser();
    const location = useLocation();

    // 认证检查中，显示骨架屏避免内容闪现
    if (loading) {
        return showSkeleton ? <Skeleton /> : null;
    }

    // 未登录，重定向到登录页
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 已登录，渲染子组件
    return children;
};

export default SimpleAuthGuard;
